import React, { Fragment } from 'react';
import { Card, CardBody, Col, Container, Row, Button,Input } from 'reactstrap';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { useIndicationsLaboratory } from '../../../hooks/indications/useIndicationsLaboratory';
import { ModalIndicationsLab } from '../../../components/indications/ModalIndicationsLab';


export const IndexIndicationsLaboratorys = (props) => {
    const {
        listIndications1,
        // * MODAL
        method4, modal4, modalTitle4, loading2, closeDialog,

        // * CRUD
        handleCreate2, saveCreate2,handleUpdate2, saveUpdate2,handleDelete2, saveDelete2,

        // * GLOBAL
        id_exam_indication2, indication2, handleInputChange2,validaciones2,

        // * SEARCH AND DOWNLOAD EXCEL
        handleClearIndicationsL, searchIndicationsL, handleSearchIndicationsL, 
        loadingExcel, handleExcelIndicationsL, 

        // * DIALOG DELETED
        showDeleteAlert, modalAlert, closeDeleteAlert

    } = useIndicationsLaboratory();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate2(rowData.id_exam_laboratory_indication)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete2(rowData.id_exam_laboratory_indication)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                <TitleDataTable
                                    titleTable="Listado de indicaciones de laboratorio"
                                    buttonActions={handleExcelIndicationsL}
                                    titleButton="Listado de tipos de transporte"
                                    isDisbled={loadingExcel}
                                    loadingIsDisabled={loadingExcel}
                                    titleCreate="Crear indicación de laboratorio"
                                    buttonActionsCreate={handleCreate2}
                                    actionInput={handleSearchIndicationsL}
                                    valueFilter={searchIndicationsL}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearIndicationsL}
                                />

                                <div className="table-responsive">
                                    <DataTable
                                        value={listIndications1}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >
                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        
                                        <Column 
                                            field="indication2"
                                            header="Indicaciones para el exámen" 
                                            sortable
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.indication}
                                                </span>
                                            )}
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />

                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ModalIndicationsLab
            {
                ...{
                    method4, modalTitle4, loading2, modal4, closeDialog,
                    saveCreate2,handleInputChange2,saveUpdate2,saveDelete2,validaciones2,
                    id_exam_indication2, indication2
                    
                }
            }
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar indicación de laboratorio"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar la indicación de laboratorio?"
                    alert1={true}
                    titleAlert1={indication2}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete2}
                />
            )}

        </Fragment>
    )
}
